<script lang="ts">
  import type { ToastPosition } from './Toast.svelte';

  export type ToastItem = {
    id: string;
    component: any;
    props: any;
    position?: ToastPosition;
  };

  let {
    toasts = []
  }: {
    toasts: ToastItem[];
  } = $props();

  // Group toasts by position
  let toastsByPosition = $derived.by(() => {
    const grouped = new Map<ToastPosition, ToastItem[]>();

    toasts.forEach(toast => {
      const position = toast.position || 'bottom-right';
      if (!grouped.has(position)) {
        grouped.set(position, []);
      }
      grouped.get(position)!.push(toast);
    });

    return grouped;
  });
</script>

{#each Array.from(toastsByPosition.entries()) as [position, positionToasts]}
  <div class="toast-stack" class:bottom-right={position === 'bottom-right'} class:bottom-left={position === 'bottom-left'} class:top-right={position === 'top-right'} class:top-left={position === 'top-left'} class:bottom-center={position === 'bottom-center'} class:top-center={position === 'top-center'}>
    {#each positionToasts as toast (toast.id)}
      <svelte:component this={toast.component} {...toast.props} />
    {/each}
  </div>
{/each}

<style lang="scss">
  .toast-stack {
    position: fixed;
    z-index: var(--z-modal);
    display: flex;
    flex-direction: column;
    gap: var(--spacing-md);
    pointer-events: none;

    // All child elements should allow pointer events
    :global(> *) {
      pointer-events: auto;
    }

    &.top-right {
      top: 24px;
      right: 24px;
      align-items: flex-end;
    }

    &.top-left {
      top: 24px;
      left: 24px;
      align-items: flex-start;
    }

    &.bottom-right {
      bottom: 24px;
      right: 24px;
      align-items: flex-end;
    }

    &.bottom-left {
      bottom: 24px;
      left: 24px;
      align-items: flex-start;
    }

    &.top-center {
      top: 24px;
      left: 50%;
      transform: translateX(-50%);
      align-items: center;
    }

    &.bottom-center {
      bottom: 24px;
      left: 50%;
      transform: translateX(-50%);
      align-items: center;
    }
  }

  @media (max-width: 640px) {
    .toast-stack {
      &.top-right, &.bottom-right {
        right: 16px;
      }

      &.top-left, &.bottom-left {
        left: 16px;
      }
    }
  }
</style>
